'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _dec3, _dec4, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactI18next = require('react-i18next');

var _reactRedux = require('react-redux');

var _chemist = require('chemist');

var _user = require('../../helpers/user');

var _address = require('../../helpers/address');

var _FormInput = require('../FormInput');

var _AddressPlaceholder = require('./AddressPlaceholder');

var _AddressPlaceholder2 = _interopRequireDefault(_AddressPlaceholder);

var _EnterAddressFormStyle = require('./EnterAddressFormStyle.scss');

var _EnterAddressFormStyle2 = _interopRequireDefault(_EnterAddressFormStyle);

var _addressForm = require('../../actions/addressForm');

var _presentation = require('../../actions/presentation');

var _Launcher = require('../PickupLocator/Launcher');

var _Launcher2 = _interopRequireDefault(_Launcher);

var _localisedPaths = require('../../helpers/localisedPaths');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EnterAddressForm = (_dec = (0, _chemist.configurable)(), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    addressDetailsEmail: state.addressForm.addressDetails.email,
    addressDetailsCPFNumber: state.addressForm.addressDetails.cpf_number,
    addressDetails: state.addressForm.addressDetails.ship,
    useShipping: state.addressForm.useShipping,
    clickAndCollect: state.presentation.clickAndCollect,
    pickupLocationsGPS: state.pickupLocator.gps
  };
}), _dec3 = (0, _reactI18next.translate)(), _dec4 = (0, _reactCssModules2.default)(_EnterAddressFormStyle2.default, { allowMultiple: true }), _dec(_class = _dec2(_class = _dec3(_class = _dec4(_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(EnterAddressForm, _React$Component);

  function EnterAddressForm(props, context) {
    (0, _classCallCheck3.default)(this, EnterAddressForm);

    var _this = (0, _possibleConstructorReturn3.default)(this, (EnterAddressForm.__proto__ || (0, _getPrototypeOf2.default)(EnterAddressForm)).call(this, props, context));

    _this.state = {
      shipAddress: _this.newShipAddressState(props),
      newsletterSubscribe: false,
      acceptedPrivacyPolicy: false
    };
    return _this;
  }

  (0, _createClass3.default)(EnterAddressForm, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (this.props.clickAndCollect) {
        if (!this.props.order.clickAndCollectEligible) {
          this.setClickAndCollect(false);
        }
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var newShipAddress = this.newShipAddressState(nextProps, this.state.shipAddress);
      this.setState({ shipAddress: newShipAddress });
    }
  }, {
    key: 'setClickAndCollect',
    value: function setClickAndCollect(enabled) {
      if (!enabled) {
        this.setState({ shipAddress: {} });
      }

      this.props.dispatch((0, _presentation.setClickAndCollect)(enabled));
    }
  }, {
    key: 'formErrors',
    value: function formErrors() {
      if (this.props.errors) {
        return this.props.errors.messages;
      }
      return {};
    }
  }, {
    key: 'toggleUseShippingAddress',
    value: function toggleUseShippingAddress() {
      this.props.dispatch((0, _addressForm.toggleUseShipping)());
      this.forceUpdate();
    }
  }, {
    key: 'handleAddressFieldChange',
    value: function handleAddressFieldChange(name, value) {
      var newAddress = (0, _extends4.default)({}, this.state.shipAddress, (0, _defineProperty3.default)({}, name, value));
      this.setState({ shipAddress: newAddress });
    }
  }, {
    key: 'saveEmailOnForm',
    value: function saveEmailOnForm(e) {
      this.props.dispatch((0, _addressForm.saveEmail)(e.currentTarget.value));
    }
  }, {
    key: 'saveCPFNumberOnForm',
    value: function saveCPFNumberOnForm(e) {
      this.props.dispatch((0, _addressForm.saveCPFNumber)(e.currentTarget.value));
    }
  }, {
    key: 'fetchEmailForForm',
    value: function fetchEmailForForm() {
      return this.props.addressDetailsEmail || (0, _user.orderEmail)(this.props.order, this.props.user);
    }
  }, {
    key: 'fetchCPFNumberForForm',
    value: function fetchCPFNumberForForm() {
      return this.props.addressDetailsCPFNumber || this.props.order.cpf_number || '';
    }
  }, {
    key: 'newShipAddressState',
    value: function newShipAddressState(props) {
      var previousShipAddressState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var savedShipAddress = props.order.shipAddress || {};
      var shipAddressDetail = props.shipAddressDetail || {};

      return (0, _extends4.default)({}, previousShipAddressState, {
        companyName: savedShipAddress.companyname,
        firstName: savedShipAddress.firstname,
        lastName: savedShipAddress.lastname,
        stateName: savedShipAddress.stateName,
        zipcode: shipAddressDetail.postcode || savedShipAddress.zipcode,
        phone: savedShipAddress.phone,
        address_line_1: shipAddressDetail.address_line_1 || savedShipAddress.address1,
        address_line_2: shipAddressDetail.address_line_2 || savedShipAddress.address2,
        city: shipAddressDetail.city || savedShipAddress.city
      });
    }
  }, {
    key: 'handleNewsletterSubscribeChange',
    value: function handleNewsletterSubscribeChange(value) {
      this.state.newsletterSubscribe = value;
    }
  }, {
    key: 'handleAcceptedPrivacyPolicyChange',
    value: function handleAcceptedPrivacyPolicyChange(value) {
      this.state.acceptedPrivacyPolicy = value;
    }
  }, {
    key: 'shouldRenderCPFNumber',
    value: function shouldRenderCPFNumber() {
      return this.props.country.iso === 'BR';
    }
  }, {
    key: 'shouldRenderClickAndCollectDeliveryOption',
    value: function shouldRenderClickAndCollectDeliveryOption() {
      var store = this.props.config.store;


      switch (this.props.tempPickupLocatorSet) {
        case 'yes':
          return true;
        case 'no':
          return false;
        default:
          return store.pickupLocations.enabled;
      }
    }
  }, {
    key: 'renderCPFNumber',
    value: function renderCPFNumber() {
      var t = this.props.t;


      return _react2.default.createElement(
        'fieldset',
        { styleName: 'm-fieldset' },
        _react2.default.createElement(
          _FormInput.Field,
          {
            inputName: 'cpfNumber',
            errors: this.formErrors()
          },
          _react2.default.createElement(
            _FormInput.Legend,
            null,
            t('spree.cpf_number')
          ),
          _react2.default.createElement(_FormInput.Input, {
            id: 'cpfNumber',
            name: 'order[cpf_number]',
            onChange: this.saveCPFNumberOnForm.bind(this),
            defaultValue: this.fetchCPFNumberForForm(),
            type: 'text',
            required: true
          })
        )
      );
    }
  }, {
    key: 'renderEmailField',
    value: function renderEmailField() {
      var t = this.props.t;


      if (this.props.order.user_id) {
        return '';
      }

      return _react2.default.createElement(
        'fieldset',
        { styleName: 'm-fieldset' },
        _react2.default.createElement(
          _FormInput.Legend,
          null,
          t('spree.email_address')
        ),
        _react2.default.createElement(
          _FormInput.Field,
          {
            inputName: 'email',
            errors: this.formErrors(),
            inputLabel: t('spree.email'),
            fieldRequired: true
          },
          _react2.default.createElement(_FormInput.Input, {
            id: 'email',
            name: 'order[email]',
            type: 'email',
            defaultValue: this.fetchEmailForForm(),
            onChange: this.saveEmailOnForm.bind(this),
            required: true
          })
        )
      );
    }
  }, {
    key: 'renderBillingFields',
    value: function renderBillingFields() {
      var _context;

      if (this.props.useShipping) {
        var addressDetails = this.props.addressDetails;
        var shipAddress = this.state.shipAddress;

        return _react2.default.createElement(
          'div',
          { styleName: 'a-addressPlaceholder__indent' },
          _react2.default.createElement(_AddressPlaceholder2.default, {
            address: {
              companyName: addressDetails.companyname || shipAddress.companyname,
              firstName: addressDetails.firstName || shipAddress.firstName,
              lastName: addressDetails.lastName || shipAddress.lastName,
              stateName: addressDetails.state_name || shipAddress.state_name,
              zipcode: addressDetails.zipcode || shipAddress.zipcode,
              phone: addressDetails.phone || shipAddress.phone,
              addressLine1: addressDetails.address1 || shipAddress.address_line_1,
              addressLine2: addressDetails.address2 || shipAddress.address_line_2,
              city: addressDetails.city || shipAddress.city
            }
          })
        );
      }

      return _react2.default.createElement(this.props.FormFieldsComponent, {
        prefix: 'bill',
        addresses: this.props.billAddresses,
        selectedAddressDetails: this.props.billAddressDetail,
        order: this.props.order,
        onFieldChange: this.handleAddressFieldChange.bind(this),
        errors: this.props.errors,
        country: this.props.country,
        onGetAddresses: (_context = this.props).onGetAddresses.bind(_context),
        onGetAddress: (_context = this.props).onGetAddress.bind(_context)
      });
    }
  }, {
    key: 'renderShippingFields',
    value: function renderShippingFields() {
      var _context2;

      var t = this.props.t;


      return _react2.default.createElement(
        'fieldset',
        { styleName: 'm-fieldset' },
        _react2.default.createElement(
          _FormInput.Legend,
          null,
          t('spree.shipping_address')
        ),
        _react2.default.createElement(this.props.FormFieldsComponent, {
          dispatch: this.props.dispatch,
          prefix: 'ship',
          addresses: this.props.shipAddresses,
          selectedAddressDetails: this.props.shipAddressDetail,
          order: this.props.order,
          onFieldChange: this.handleAddressFieldChange.bind(this),
          errors: this.formErrors(),
          country: this.props.country,
          onGetAddresses: (_context2 = this.props).onGetAddresses.bind(_context2),
          onGetAddress: (_context2 = this.props).onGetAddress.bind(_context2)
        })
      );
    }
  }, {
    key: 'renderClickAndCollectVolumeLimitError',
    value: function renderClickAndCollectVolumeLimitError() {
      return _react2.default.createElement(
        'span',
        { styleName: 'm-delivery-method-unavailable-error' },
        'Not available, maximum of 2 cans exceeded'
      );
    }

    // TODO: what if a customer fills in their shipping
    // address then changes their delivery choice?

  }, {
    key: 'renderDeliveryMethodChoice',
    value: function renderDeliveryMethodChoice() {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'fieldset',
          { styleName: 'm-fieldset' },
          _react2.default.createElement(
            _FormInput.Legend,
            null,
            'Delivery Method'
          ),
          _react2.default.createElement(
            'div',
            { styleName: (0, _address.getDeliveryMethodStyleName)(true) },
            _react2.default.createElement(_FormInput.Radio, {
              id: 'delivery-standard',
              name: 'delivery-choice',
              value: 'delivery-standard',
              onClick: function onClick() {
                return _this2.setClickAndCollect.call(_this2, false);
              },
              checked: !this.props.clickAndCollect
            }),
            _react2.default.createElement(
              'label',
              { htmlFor: 'delivery-standard' },
              'Delivery standard'
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: (0, _address.getDeliveryMethodStyleName)(this.props.order.clickAndCollectEligible) },
            _react2.default.createElement(_FormInput.Radio, {
              id: 'click-and-collect',
              name: 'delivery-choice',
              value: 'click-and-collect',
              onClick: function onClick() {
                return _this2.setClickAndCollect.call(_this2, true);
              },
              checked: this.props.clickAndCollect,
              disabled: !this.props.order.clickAndCollectEligible
            }),
            _react2.default.createElement(
              'label',
              { htmlFor: 'click-and-collect' },
              'Collect at a collection point near you'
            ),
            !this.props.order.clickAndCollectEligible && this.renderClickAndCollectVolumeLimitError()
          ),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'p',
              null,
              _react2.default.createElement('img', {
                src: require('./assets/collect-plus-logo.jpg'),
                alt: 'CollectPlus',
                className: 'pull-left',
                styleName: 'collect-plus-logo'
              }),
              'Choose to have your order delivered to one of thousands of CollectPlus points across the UK, open early \u2018til late, 7 days a week.'
            )
          )
        )
      );
    }
  }, {
    key: 'renderAddressReplicationChoice',
    value: function renderAddressReplicationChoice() {
      var t = this.props.t;


      return _react2.default.createElement(
        'div',
        { styleName: 'm-formField' },
        _react2.default.createElement(_FormInput.Checkbox, {
          id: 'use_shipping',
          name: 'use_shipping',
          defaultChecked: this.props.useShipping,
          onChange: this.toggleUseShippingAddress.bind(this)
        }),
        _react2.default.createElement(
          _FormInput.Label,
          { htmlFor: 'use_shipping', className: 'a-label--checkbox' },
          t('spree.use_shipping_address')
        )
      );
    }
  }, {
    key: 'renderNewsletterSubscribeField',
    value: function renderNewsletterSubscribeField() {
      var _this3 = this;

      var t = this.props.t;

      return _react2.default.createElement(
        _FormInput.Field,
        { inputName: 'newsletter_subscribe' },
        _react2.default.createElement(_FormInput.Checkbox, {
          id: 'newsletter_subscribe',
          name: 'newsletter_subscribe',
          defaultChecked: false,
          onChange: function onChange(e) {
            return _this3.handleNewsletterSubscribeChange(e.target.checked);
          },
          style: { marginTop: '10px' }
        }),
        _react2.default.createElement(
          _FormInput.Label,
          {
            htmlFor: 'newsletter_subscribe',
            className: 'a-label--checkbox',
            style: { marginTop: '8px' }
          },
          t('subscribe_to_newsletter')
        )
      );
    }
  }, {
    key: 'renderPrivacyPolicyField',
    value: function renderPrivacyPolicyField() {
      var _this4 = this;

      var t = this.props.t;


      return _react2.default.createElement(
        _FormInput.Fieldset,
        { extraStyle: 'privacyPolicyField' },
        _react2.default.createElement(
          _FormInput.Field,
          { inputName: 'accepted_privacy_policy' },
          _react2.default.createElement(_FormInput.Checkbox, {
            id: 'accepted_privacy_policy',
            name: 'accepted_privacy_policy',
            defaultChecked: false,
            onChange: function onChange(e) {
              return _this4.handleAcceptedPrivacyPolicyChange(e.target.checked);
            },
            required: true
          }),
          _react2.default.createElement(
            _FormInput.Label,
            {
              htmlFor: 'accepted_privacy_policy',
              className: 'a-label--checkbox'
            },
            t('spree.privacy_policy_checkbox.pre_text'),
            '\xA0',
            _react2.default.createElement(
              'a',
              {
                className: 'a-link',
                href: (0, _localisedPaths.localisedPath)(this.props.config.store, 'termsConditionsPath', this.props.config.store.defaultLocale),
                target: '_blank',
                rel: 'noopener noreferrer'
              },
              t('spree.privacy_policy_checkbox.terms_and_conditions')
            ),
            t('spree.privacy_policy_checkbox.mid_text'),
            '\xA0',
            _react2.default.createElement(
              'a',
              {
                className: 'a-link',
                href: (0, _localisedPaths.localisedPath)(this.props.config.store, 'privacyPolicyPath', this.props.config.store.defaultLocale),
                target: '_blank',
                rel: 'noopener noreferrer'
              },
              t('spree.privacy_policy_checkbox.privacy_policy')
            )
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          config = _props.config;
      var theme = config.theme;


      return _react2.default.createElement(
        'div',
        null,
        theme === 'woodcare' && this.renderEmailField(),
        this.shouldRenderClickAndCollectDeliveryOption() && this.renderDeliveryMethodChoice(),
        this.props.clickAndCollect ? _react2.default.createElement(_Launcher2.default, { gps: this.props.pickupLocationsGPS }) : this.renderShippingFields(),
        theme !== 'woodcare' && this.renderEmailField(),
        this.shouldRenderCPFNumber() && this.renderCPFNumber(),
        _react2.default.createElement(
          'fieldset',
          { styleName: 'm-fieldset m-fieldset--billing' },
          _react2.default.createElement(
            _FormInput.Legend,
            { smallMobile: true },
            t('spree.billing_address')
          ),
          !this.props.clickAndCollect && this.renderAddressReplicationChoice(),
          this.renderBillingFields()
        ),
        this.props.config.store.hasPrivacyPolicy && this.renderPrivacyPolicyField(),
        this.props.config.store.hasNewsletterSubscribe && this.renderNewsletterSubscribeField()
      );
    }
  }]);
  return EnterAddressForm;
}(_react2.default.Component), _class2.propTypes = {
  order: _react.PropTypes.object.isRequired,
  errors: _react.PropTypes.object,
  country: _react.PropTypes.object.isRequired,
  user: _react.PropTypes.object,
  onGetAddresses: _react.PropTypes.func.isRequired,
  onGetAddress: _react.PropTypes.func.isRequired,
  shipAddresses: _react.PropTypes.arrayOf(_react.PropTypes.shape({
    id: _react.PropTypes.string,
    label: _react.PropTypes.string
  })),
  shipAddressDetail: _react.PropTypes.shape({
    address_1: _react.PropTypes.string,
    address_2: _react.PropTypes.string,
    city: _react.PropTypes.string
  }),
  billAddresses: _react.PropTypes.arrayOf(_react.PropTypes.shape({
    id: _react.PropTypes.string,
    label: _react.PropTypes.string
  })),
  billAddressDetail: _react.PropTypes.shape({
    address_1: _react.PropTypes.string,
    address_2: _react.PropTypes.string,
    city: _react.PropTypes.string
  })
}, _class2.defaultProps = {
  onGetAddresses: function onGetAddresses() {},
  onGetAddress: function onGetAddress() {}
}, _temp)) || _class) || _class) || _class) || _class);
exports.default = EnterAddressForm;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/components/AddressForm/EnterAddressForm.js
// module id = 2260
// module chunks = 0